import { render, staticRenderFns } from "./RequisitionsTable.vue?vue&type=template&id=3bad971b&scoped=true&"
import script from "./RequisitionsTable.vue?vue&type=script&lang=ts&"
export * from "./RequisitionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionsTable.vue?vue&type=style&index=0&id=3bad971b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad971b",
  null
  
)

export default component.exports